import z from 'zod';

import { defineCommand } from '@nesso/common-contracts/define';
import { practiceIdSchema } from '@nesso/common-contracts/ids';
import { metadata } from '@nesso/common-contracts/schema-metadata';

export const MERCHANT_CREATE_ONBOARDING_LINK_TYPE = 'merchant/create-onboarding-link';

export const merchantCreateOnboardingLink = defineCommand(
    MERCHANT_CREATE_ONBOARDING_LINK_TYPE,
    z.object({
        practiceId: practiceIdSchema.meta(metadata.nonSensitive),
    }),
    z.object({
        url: z.string(),
    }),
);

export const MERCHANT_CREATE_DASHBOARD_LINK_TYPE = 'merchant/create-dashboard-link';

export const merchantCreateDashboardLink = defineCommand(
    MERCHANT_CREATE_DASHBOARD_LINK_TYPE,
    z.object({
        practiceId: practiceIdSchema.meta(metadata.nonSensitive),
    }),
    z.object({
        url: z.string(),
    }),
);

export const MERCHANT_PREFILL_ONBOARDING_TYPE = 'merchant/prefill-onboarding';

export const merchantPrefillOnboarding = defineCommand(
    MERCHANT_PREFILL_ONBOARDING_TYPE,
    z.object({
        token: z.string().min(1),
    }),
    z.object({
        practiceId: practiceIdSchema.meta(metadata.nonSensitive),
        email: z.string(),
    }),
);

const KMS_PLAINTEXT_MAX_BYTES = 4096;

export const MERCHANT_COMPLETE_ONBOARDING_TYPE = 'merchant/complete-onboarding';

export const merchantCompleteOnboarding = defineCommand(
    MERCHANT_COMPLETE_ONBOARDING_TYPE,
    z.object({
        practiceId: practiceIdSchema.meta(metadata.nonSensitive),
        externalMerchantId: z.string().min(1).max(64).meta(metadata.nonSensitive),
        externalAccountId: z.string().min(1).max(64),
        apiToken: z
            .string()
            .min(1)
            .refine((value) => new TextEncoder().encode(value).length <= KMS_PLAINTEXT_MAX_BYTES, {
                message: `Must be at most ${KMS_PLAINTEXT_MAX_BYTES} bytes`,
            }),
    }),
);

export const MERCHANT_CREATE_TYPE = 'merchant/create';

export const merchantCreate = defineCommand(
    MERCHANT_CREATE_TYPE,
    z.object({
        practiceId: practiceIdSchema.meta(metadata.nonSensitive),
        externalMerchantId: z.string().min(1).max(64).meta(metadata.nonSensitive),
        externalAccountId: z.string().min(1).max(64),
        apiTokenCiphertext: z.string().min(1),
    }),
);
